var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificaionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5777 27.5C18.1653 28.0186 18.9372 28.3333 19.7825 28.3333C20.6279 28.3333 21.3998 28.0186 21.9874 27.5M24.7825 16.6667C24.7825 15.3406 24.2557 14.0688 23.3181 13.1311C22.3804 12.1935 21.1086 11.6667 19.7825 11.6667C18.4564 11.6667 17.1847 12.1935 16.247 13.1311C15.3093 14.0688 14.7825 15.3406 14.7825 16.6667C14.7825 19.2418 14.1329 21.005 13.4072 22.1712C12.7951 23.1549 12.4891 23.6468 12.5003 23.784C12.5127 23.9359 12.5449 23.9938 12.6673 24.0847C12.7779 24.1667 13.2764 24.1667 14.2732 24.1667H25.2918C26.2887 24.1667 26.7871 24.1667 26.8977 24.0847C27.0201 23.9938 27.0523 23.9359 27.0648 23.784C27.076 23.6468 26.7699 23.1549 26.1578 22.1712C25.4321 21.005 24.7825 19.2418 24.7825 16.6667Z",
    stroke: "#4A4F5C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaionIcon);
export default __webpack_public_path__ + "static/media/notificaion_icon.31fe22f22f677aac813521826360aa9c.svg";
export { ForwardRef as ReactComponent };